<template>
  <div class="mobile_view">
    <div class="right-content">
      <quiz-overview></quiz-overview>
    </div>
    <div class="left-content">
      <div class="quiz-content">
        <h2>Everything So Far</h2>
      </div>

      <div class="quiz-answers">
        <ul>
          <li>
            <strong>You are: </strong> <span style="text-transform: capitalize;">{{ getGender }}</span>, {{ getAge }}
          </li>
          <li>
            <strong>You have a history, or a family history of: </strong>
            <span style="text-transform: capitalize;">{{ history }}</span>
          </li>
          <li>
            <strong>You are concerned or discussed about: </strong>
            <span style="text-transform: capitalize;">{{ healthIssue }}</span>
          </li>
          <li>
            <span style="text-transform: capitalize;">{{ getAdditionalInfo }}</span>
          </li>
        </ul>
      </div>

      <div class="button-content">
        <button class='btn-prev w-btn us-btn-style_2' @click="prevQuiz">
          <span class="w-btn-label">&larr; Prev</span>
        </button>
        <button class='getstart btn-active btn-next w-btn us-btn-style_1' @click="nextQuiz">
          <span class="w-btn-label">Book Now &rarr;</span>
        </button>
      </div>
    </div>

  </div>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex';
import QuizOverview from './QuizOverview.vue';

export default {
  name: 'QuizFinal',

  components: { QuizOverview },

  data() {
    return {
      additionalInfo: '',
    };
  },

  computed: {
    ...mapGetters( [
      'getGender',
      'getAge',
      'getHistory',
      'getHealthIssue',
      'getDiscuss',
      'getAdditionalInfo',
    ] ),

    history() {
      let selected = [];
      Object.keys( this.getHistory ).forEach( key => {
        if ( this.getHistory[ key ].selected ) {
          selected.push( this.getHistory[ key ].desc );
        }
      } );

      return selected.join( ' , ' );
    },

    healthIssue() {
      let selected = [];
      Object.keys( this.getHealthIssue ).forEach( key => {
        if ( this.getHealthIssue[ key ].selected ) {
          selected.push( this.getHealthIssue[ key ].desc );
        }
      } );

      return selected.join( ' , ' );
    },

    discuss() {
      let selected = [];
      Object.keys( this.getDiscuss ).forEach( key => {
        if ( this.getDiscuss[ key ].selected ) {
          selected.push( this.getDiscuss[ key ].desc );
        }
      } );

      return selected.join( ' , ' );
    }
  },

  methods: {
    ...mapMutations( [
      'setStep',
    ] ),

    prevQuiz() {
      this.setStep( 6 );
      const $form = document.getElementById( 'form' );
      $form.scrollIntoView();
    },

    nextQuiz() {
      let imchsp = this.getGender + " (" + this.getAge + ")";

      let imchso = "";
      Object.keys( this.getHistory ).forEach( key => {
        if ( this.getHistory[ key ].selected ) {
          imchso += this.getHistory[ key ].desc + ",";
        }
      } );

      imchso = imchso.substring( 0, imchso.length - 1 );

      let healthIssue = "";
      Object.keys( this.getHealthIssue ).forEach( key => {
        if ( this.getHealthIssue[ key ].selected ) {
          healthIssue += this.getHealthIssue[ key ].desc + ",";
        }
      } );

      healthIssue = healthIssue.substring( 0, healthIssue.length - 1 );

      // Get redirect URL from shortcode
      const $formUrl = document.getElementById( 'form-url' );
      const formUrl = $formUrl.value;

      let additionalInfo = '';
      if ( this.getAdditionalInfo !== '' ) {
        additionalInfo = '&additionalInfo=' + this.getAdditionalInfo;
      }

      document.location.href = formUrl + "?imchsp=" + imchsp + "&imchso=" + imchso + "&healthIssue=" + healthIssue + additionalInfo;
    },

    editStep( step ) {
      this.setStep( step );
    }
  }
}
</script>

<style scoped>

ul li b {
  color: var(--imc-primary-color);
}

ul,
li {
  list-style: none;
  padding: 0;
  margin: 0;
}

ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-top: 1.25rem;
}

ul li {
  position: relative;
  padding: 0.5rem 0;
  width: 100%;
}

li span:empty {
  display: none;
}

</style>